import React from 'react';
import Link from "@mui/material/Link";


export default function BasicLink({label, link, openInNewTab}) {

  return(
    <Link sx={{
      width: '100%',
      fontSize: '16px',
      padding: '0',
      color: '#125e82',
      fontFamily: 'LarsseitMedium',
      textTransform: 'none',
      ':hover': {
        color: '#1c465e',
        backgroundColor: 'unset'
      }
    }} href={link} target={openInNewTab ? '_blank' : ''} rel="noopener" underline="none">
      {label}
    </Link>
  )
}